import React, {Fragment} from "react";

/**
 * Form displaying different inputs.
 * @author Alizée Grand
 * @version 1.0
 * @creation 25/04/2022
 * @last_update 25/04/2022
 **/
class FormIdentification extends React.Component<{
    /**
     * Inputs to be displayed.
     */
    inputs: React.ReactNode[],
    /**
     * Form id.
     */
    id?: string,
}> {

    render() {

        return (

            <form id={this.props.id}>
                {
                    this.props.inputs.map((input, key) => (
                        <Fragment key={key}>
                            {input}
                        </Fragment>
                    ))
                }
            </form>

        );

    };

}

export default FormIdentification;
